import { change, Field, reduxForm } from 'redux-form';
import {  renderCheckBox,  renderTextField,  renderAutoCompleteSingleSelect, isInteger} from '../../../../../../components/reduxFields';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import React from 'react';
import { getPromptCodeDetail, savePromptCode, getMasterData } from './actions/PromptCodeActions';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../../components/buttons';
import SmallLoader from '../../../../../../img/small-loader.gif';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../../modules/AppConfig/actions';
import { MODULE } from './constants/ApiConstants';

const validate = (values) => {
  const errors = {};
  if (!values.promptCodeId) {
    errors.promptCodeId = 'Please select prompt code';
  }
  if (!values.abbreviation) {
    errors.abbreviation = 'Please enter abbreviation';
  }
  return errors;
};


/**
 * Dialog content can be scrollable.
 */
class PatientPromptCodeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleNewRequest = this.handleNewRequest.bind(this);
  }

  componentWillMount() {
    if (this.props.promptCodeId) {
      this.props.getPromptCodeDetail(this.props.promptCodeId);
    }
    const masterData = { masterdata: 'MASTERPROMPTCODES' };
    this.props.getMasterData(masterData);
  }

  handleOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };
  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  onSubmitHandler(formProps) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }

    let postData = {
      "id": this.props.promptCodeId || 0,
      "patientId": this.props.patientId,
      "promptCodeId": formProps.promptCodeId,
      "abbreviation": formProps.abbreviation,
      "scoreAsIndependent": formProps.scoreAsIndependent || false,
      "dtt": formProps.dtt || false,
      "ta": formProps.ta || false,
      "maintenance": formProps.maintenance || false,
      "peakScore": formProps.peakScore || 0,
      "isActive":  formProps.isActive || false
    }

    // console.log(postData);
    this.props.savePromptCode(postData);
    this.props.closeDialog();
  }

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.state.maintenanceLevelId || 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    const selectedPromptCode = (this.props.masterPromptCodes || []).find(obj => obj.id === selectedRecord.value);

    const { abbreviation, scoreAsIndependent, dtt, ta, maintenance, peakScore, isActive } = selectedPromptCode || {};

    this.props.dispatch(change('PatientPromptCodeModalForm', 'abbreviation', abbreviation));
    this.props.dispatch(change('PatientPromptCodeModalForm', 'scoreAsIndependent', scoreAsIndependent));
    this.props.dispatch(change('PatientPromptCodeModalForm', 'dtt', dtt));
    this.props.dispatch(change('PatientPromptCodeModalForm', 'ta', ta));
    this.props.dispatch(change('PatientPromptCodeModalForm', 'maintenance', maintenance));
    this.props.dispatch(change('PatientPromptCodeModalForm', 'peakScore', peakScore));
    this.props.dispatch(change('PatientPromptCodeModalForm', 'isActive', isActive));

  }


  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <div>
        <Dialog
          className="custom_modal"
          title={this.props.promptCodeId ? 'Edit Prompt Code' : 'Add Prompt Code'}
          modal={false}
          open={this.state.open}
          actions={actions}
          autoScrollBodyContent={true}
        >
          {this.renderLoading()}
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form">
                <div className="row">
                  <div className='col-sm-6 require mt-35'>
                    <Field
                      name="promptCodeId"
                      label="Prompt Code"
                      options={this.props.masterPromptCodes}
                      handleNewRequest={this.handleNewRequest}
                      component={renderAutoCompleteSingleSelect}
                      openOnFocus={true}
                    />
                  </div>
                  <div className='col-sm-3 require'>
                    <Field
                      name="abbreviation"
                      type="text"
                      floatingLabelText="Abbreviation"
                      component={renderTextField}
                      fullWidth={true}
                      maxLength="5"
                    />
                  </div>
                  <div className="col-sm-3">
                    <Field
                      name="peakScore"
                      type="text"
                      maxLength="2"
                      label="PEAK Score"
                      component={renderTextField}
                      normalize={isInteger}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="scoreAsIndependent"
                      label="Score As Independent"
                      component={renderCheckBox}
                      value={true}
                    />
                  </div>
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="dtt"
                      label="DTT"
                      component={renderCheckBox}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="ta"
                      label="TA"
                      component={renderCheckBox}
                    />
                  </div>
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="maintenance"
                      label="Maintenance"
                      component={renderCheckBox}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4">
                    <Field className="mt20 mb0 custm_check"
                      name="isActive"
                      label="Is Active"
                      component={renderCheckBox}
                    />
                  </div>
                  <div className="col-sm-8">
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

//const selector = formValueSelector('PatientPromptCodeModalForm');
const mapStateToProps = (state, ownProps) => {
  let initialValueData = {
    isActive: true,
  };
  if (ownProps.promptCodeId && state.patient_prompt_code.promptCodeDetail) {
    initialValueData = state.patient_prompt_code.promptCodeDetail.data;
  }
  return {
    initialValues: initialValueData,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    promptCodeDetail: state.patient_prompt_code.promptCodeDetail,
    masterPromptCodes: state.patient_prompt_code.masterData && state.patient_prompt_code.masterData.masterPromptCodes,
    loading: state.patient_prompt_code.loading,
  };
};

PatientPromptCodeModal = reduxForm({
  form: 'PatientPromptCodeModalForm', // a unique identifier for this form
  validate,
  enableReinitialize: true,
})(PatientPromptCodeModal);

export default connect(mapStateToProps, { savePromptCode, getPromptCodeDetail, getMasterData, checkFieldExistence, clearFieldErrorArray })(PatientPromptCodeModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/promptCodes/propmt_codes_modal.js